/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Pdf_TotalInputs */

const en_reports_pdf_total = /** @type {(inputs: Reports_Pdf_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const pt_br2_reports_pdf_total = /** @type {(inputs: Reports_Pdf_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

/**
* | output |
* | --- |
* | "Total" |
*
* @param {Reports_Pdf_TotalInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_pdf_total = /** @type {((inputs?: Reports_Pdf_TotalInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Pdf_TotalInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_pdf_total(inputs)
	return pt_br2_reports_pdf_total(inputs)
});